import { createAction, props } from '@ngrx/store';

import { AttentionLimits } from '../../models/attention-limits.model';

export const loadAttentionLimitsSuccess = createAction(
  '[AttentionLimits] Load production attention limits succeeded',
  props<{ attentionLimits: AttentionLimits }>(),
);

export const saveAttentionLimits = createAction(
  '[AttentionLimits] Save production attention limits',
  props<{ attentionLimits: AttentionLimits }>(),
);

export const saveAttentionLimitsSucceedeed = createAction(
  '[AttentionLimits] Save production attention limits succeeded',
);

export const editAttentionLimits = createAction(
  '[AttentionLimits] Load production attention limits and display edit dialog',
);

export const loadAttentionLimitsRequest = createAction(
  '[AttentionLimits] Load production attention limits for specific date',
  props<{ date: string }>(),
);

export const loadAttentionLimitsByDateSuccess = createAction(
  '[AttentionLimits] Load production attention limits by date',
  props<{ date: string; attentionLimits: AttentionLimits }>(),
);
